<template>
  <svg
    width="61"
    height="60"
    viewBox="0 0 61 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30.5" cy="30" r="30" class="fill-bkk-100" />
    <path
      d="M20.2289 45.9594C23.5798 46.2788 26.8253 45.9159 29.9654 44.8708"
      stroke="#383838"
      stroke-linecap="round"
    />
    <path
      d="M28.7721 26.0143C31.0863 24.8723 34.1171 24.8828 36.743 26.0967"
      stroke="#383838"
      stroke-linecap="round"
    />
    <path
      d="M8.27703 26.0143C10.5912 24.8723 13.622 24.8828 16.2479 26.0967"
      stroke="#383838"
      stroke-linecap="round"
    />
    <path
      d="M23.5 37L18.5 35.8221V22"
      stroke="#383838"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.34573 14.7159C9.19486 13.3556 12.9201 13.3556 16.1427 14.7807"
      stroke="#383838"
      stroke-linecap="round"
    />
    <path
      d="M28.1621 14.7159C31.0113 13.3556 34.7365 13.3556 37.9591 14.7807"
      stroke="#383838"
      stroke-linecap="round"
    />
  </svg>
</template>
